
<mat-form-field>
  <mat-label>Select Item(s)</mat-label>
  <mat-select [(ngModel)]="ids" (selectionChange)="change($event.value)" multiple #select="ngModel">
    <mat-select-trigger>
      {{title}}
    </mat-select-trigger>
    <mat-option disabled="disabled" class="filter-option">
      <button mat-raised-button class="mat-primary fill text-sm" (click)="selectAll(select, list)">
        Select All
      </button>
      <button mat-raised-button class="mat-accent fill text-sm" (click)="deselectAll(select)">
        Deselect All
      </button>
    </mat-option>
    @for (h of list; track h) {
      <mat-option [value]="h.id">{{h.name}}</mat-option>
    }
  </mat-select>
</mat-form-field>

@if (displayList) {
  <div class="row">
    <div class="col-12">
      <h5>Selected Items:</h5>
      <ul class="list">
        @for (item of ids; track item) {
          <li>
            {{item}}
          </li>
        }
      </ul>
    </div>
  </div>
}